import { CommonModule } from '@angular/common';
import { NgModule} from '@angular/core';
import {
  BrandMinimizeDirective,
  MobileSidebarToggleDirective,
  SidebarToggleDirective,
  SidebarMinimizeDirective,
  SidebarOffCanvasCloseDirective
} from './layout.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    BrandMinimizeDirective,
    MobileSidebarToggleDirective,
    SidebarToggleDirective,
    SidebarMinimizeDirective,
    SidebarOffCanvasCloseDirective
  ],
  declarations: [
    BrandMinimizeDirective,
    MobileSidebarToggleDirective,
    SidebarToggleDirective,
    SidebarMinimizeDirective,
    SidebarOffCanvasCloseDirective
  ]
})
export class LayoutModule { }
